import { IonIcon } from '@ionic/react'
import { SynerallInvoice } from '@vae/server/src/modules/ExternalAPIs/Synerall/synerallTypes'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { downloadOutline } from 'ionicons/icons'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/actions/Button'
import { ObjectContext } from '../../../contexts/objectContext/ObjectContext'
import { trpc } from '../../../modules/trpc'
import { downloadBreakdown, downloadPDF } from '../utils/invoiceDownloadUtils'
dayjs.extend(customParseFormat)

const InvoiceCard: React.FC<{ invoice: SynerallInvoice; late: boolean; paid: boolean }> = ({
	invoice,
	late,
	paid,
}) => {
	const object = useContext(ObjectContext)
	const parsedDueDate = invoice.DueDate?.split('T')[0].split('-').reverse().join('.')
	const { t } = useTranslation('pages_invoices')

	const { data } = trpc.synerall.downloadBreakdown.useQuery<string>({
		invoiceId: Number(invoice.Number),
	})

	const handleDownloadInvoice = (e: React.MouseEvent) => {
		e.stopPropagation()
		downloadPDF(invoice)
	}

	const handleDownloadBreakdown = (e: React.MouseEvent) => {
		e.stopPropagation()
		downloadBreakdown(data, invoice, object.spotMarginal ?? 0)
	}

	const defaultStyle = 'invoice-card bg-white dark:bg-surface-dark drop-shadow-lg'

	// determine whether to show unpaid section
	const showUnpaid = invoice.Amount !== invoice.Balance

	return (
		<div className={late ? `${defaultStyle} late` : defaultStyle}>
			<div className='state'>
				<h2 className='text-brand-secondary-100-light dark:text-brand-primary-100-dark'>
					{paid ? t('invoiceCard.paid') : late ? t('invoiceCard.late') : t('invoiceCard.unpaid')}
				</h2>
				<div className='due-date text-text-grey-200 dark:text-text-grey-100 !m-0 !mb-2'>
					{t('invoiceCard.erapaiva')} {parsedDueDate}
				</div>
				<div className='text-text-grey-200 dark:text-text-grey-100 text-sm'>
					{t('invoiceCard.totalBill')}
				</div>

				<span className='text-brand-primary-100-light dark:text-brand-secondary-100-dark font-semibold !text-xl'>
					{invoice.Amount.toFixed(2).replace('.', ',')}{' '}
					<span className='text-[#666778] dark:text-[#d2d2d2] text-lg'>€</span>
				</span>

				{showUnpaid && (
					<>
						<div className='text-text-grey-200 dark:text-text-grey-100 text-sm'>
							{t('invoiceCard.unpaidAmount')}
						</div>
						<span className='text-brand-primary-100-light dark:text-brand-secondary-100-dark font-semibold !text-xl'>
							{invoice.Balance.toFixed(2).replace('.', ',')}{' '}
							<span className='text-[#666778] dark:text-[#d2d2d2] text-lg'>€</span>
						</span>
					</>
				)}
			</div>
			<div className='flex flex-col gap-3'>
				<Button
					onClick={handleDownloadInvoice}
					className='!p-0 m-0 h-10 !text-[0.9375rem]'
					size='small'
				>
					<IonIcon icon={downloadOutline} className='mr-2' />
					<span>{t('invoiceCard.download')}</span>
				</Button>
				<Button
					onClick={handleDownloadBreakdown}
					disabled={!data}
					className='hollow border border-brand-primary-100-light dark:border-brand-primary-100-dark !p-0 m-0 h-10  !text-[0.9375rem]'
					size='small'
				>
					<IonIcon icon={downloadOutline} className='mr-2' />
					<span>{t('invoiceCard.csv')}</span>
				</Button>
			</div>
		</div>
	)
}

export default InvoiceCard
